/**
 * Product card secondary-image hydrator.
 * PERF V3.11: secondary/hover images are not requested on initial load and
 * are never requested on touch-only/mobile devices. On fine-pointer desktop,
 * hydrate exactly once on first real hover.
 */
(() => {
  'use strict';

  const canHover = () =>
    window.matchMedia &&
    window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;

  const hydrate = (img) => {
    if (!img || img.dataset.secondaryLoaded === 'true' || !canHover()) return;

    const src = img.dataset.secondarySrc;
    const srcset = img.dataset.secondarySrcset;
    const sizes = img.dataset.secondarySizes;
    if (!src) return;

    img.dataset.secondaryLoaded = 'true';

    const markReady = () => {
      img.removeAttribute('data-secondary-pending');
      img.closest('.media--secondary-pending')?.classList.remove('media--secondary-pending');
    };

    img.addEventListener('load', markReady, { once: true });
    img.addEventListener('error', () => {
      // Keep the primary image visible if the hover asset cannot load.
      img.dataset.secondaryLoaded = 'false';
    }, { once: true });

    if (sizes) img.sizes = sizes;
    if (srcset) img.srcset = srcset;
    img.src = src;

    if (img.complete && img.naturalWidth > 1) markReady();
  };

  const hydrateFromEvent = (event) => {
    if (!canHover()) return;
    const card = event.target?.closest?.('.collection-product-card.quickview--hover');
    if (!card) return;
    hydrate(card.querySelector('img.media--second[data-secondary-pending="true"]'));
  };

  document.addEventListener('pointerover', hydrateFromEvent, { passive: true });

  // Theme editor / keyboard users can still preview the alternate image without
  // changing the mobile network behavior.
  document.addEventListener('focusin', (event) => {
    if (!canHover()) return;
    const card = event.target?.closest?.('.collection-product-card.quickview--hover');
    if (!card) return;
    hydrate(card.querySelector('img.media--second[data-secondary-pending="true"]'));
  });
})();
